

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// getReferrerCustomerRewardsByCustomerId
// GETREFERRERCUSTOMERREWARDSBYCUSTOMERID
const GETREFERRERCUSTOMERREWARDSBYCUSTOMERID= createAsyncThunk(
  "getReferrerCustomerRewardsByCustomerId/getReferrerCustomerRewardsByCustomerId",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getReferrerCustomerRewardsByCustomerIdSlice = createSlice({
  name: "getReferrerCustomerRewardsByCustomerIdSlice",
  initialState: {
    getReferrerCustomerRewardsByCustomerId: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetReferrerCustomerRewardsByCustomerId: (state) => {
        state.getReferrerCustomerRewardsByCustomerId.loading = false
        state.getReferrerCustomerRewardsByCustomerId.error = false
        state.getReferrerCustomerRewardsByCustomerId.data = []
        state.getReferrerCustomerRewardsByCustomerId.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETREFERRERCUSTOMERREWARDSBYCUSTOMERID.fulfilled, (state, action) => {
      state.getReferrerCustomerRewardsByCustomerId = {
        ...state.getReferrerCustomerRewardsByCustomerId,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETREFERRERCUSTOMERREWARDSBYCUSTOMERID.pending, (state, action) => {
      state.getReferrerCustomerRewardsByCustomerId = {
        ...state.getReferrerCustomerRewardsByCustomerId,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETREFERRERCUSTOMERREWARDSBYCUSTOMERID.rejected, (state, action) => {
      state.getReferrerCustomerRewardsByCustomerId = {
        ...state.getReferrerCustomerRewardsByCustomerId,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getReferrerCustomerRewardsByCustomerIdAction = {
    GETREFERRERCUSTOMERREWARDSBYCUSTOMERID,
};

export { getReferrerCustomerRewardsByCustomerIdAction };
export default getReferrerCustomerRewardsByCustomerIdSlice.reducer;
export const {setInitialStateOfgetReferrerCustomerRewardsByCustomerId} = getReferrerCustomerRewardsByCustomerIdSlice.actions
